// import { localStorage } from "react-native";


const getUserId = async () => {
    // let userId = '';
    // try {
    //     userId = await localStorage.getItem('secureToken') || 'none';

    // } catch (error) {
    //     // Error retrieving data
    //     console.log(error.message);
    // }
    // //console.log(userId)
    // return userId;


    let userId = '';
    try {
        userId =  localStorage.getItem('@userToken') || 'none';

    } catch (error) {
        // Error retrieving data
        console.log(error.message);
    }
    //console.log(userId)
    return userId;
}

export default getUserId